import { ListView } from '@/types';

import { toListViewCreateInput, toListViewUpdateInput } from './resourceMutationPayloads';
import { createSanitizedResourceService, QueryParams } from './resources';

const base = createSanitizedResourceService<
    ListView,
    ReturnType<typeof toListViewCreateInput>,
    ReturnType<typeof toListViewUpdateInput>
>('/api/list-views', toListViewCreateInput, toListViewUpdateInput);

export const listViewService = {
    ...base,
    list: <TParams extends QueryParams = QueryParams>(params?: TParams) => base.list(params),
    setArchived: (id: string, archived: boolean) => base.update(id, { archived }),
    setFavorite: (id: string, favorited: boolean) => base.update(id, { favorited }),
    setLocked: (id: string, locked: boolean) => base.update(id, { locked }),
};
